





















import { Component, Prop, Watch } from "vue-property-decorator";
import ParticaBaseView from "../Base/ParticaBaseView.vue";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import SearchQuery from "@/Ui-Components/Article/Search/SearchQuery.vue";
import SearchResultsDashboard from "@/Ui-Components/Article/Search/SearchResultsDashboard.vue";
import SearchFacets from "@/Ui-Components/Article/Search/SearchFacets.vue";
import SearchResultCount from "@/Ui-Components/Article/Search/SearchResultCount.vue";
import { ContentSearchHit, ContentSearchDataOfContentSearchHit } from "../../Generated/ParticaAPI";
import { IArticleSearchService } from "../../BusinessServices/articlesearch";
import { ArrayUtils } from "../../BusinessServices/arrayutils";

@Component({
	name: "ArticleSearch",
	components: { ParticaError, ParticaColumnContainer, SearchQuery, SearchResultsDashboard, SearchFacets, SearchResultCount }
})
export default class ArticleSearch extends ParticaBaseView {
	@Prop() private accountId: number;
	@Prop() private publicationId: number;
	@Prop() private articleType: string;
	@Prop() private orderby: string;
	@Prop() private facets: string[];
	@Prop({ default: -1 }) private firechange: number;

	private articleSearchService: IArticleSearchService;
	private searchData: ContentSearchDataOfContentSearchHit = new ContentSearchDataOfContentSearchHit(
		{
			query: "*",
			facets: [] as string[],
			filters: {},
			top: 25 as number
		} as ContentSearchDataOfContentSearchHit);

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.SEARCH_FACET_UPDATE: {
					if (this.searchData.filters === undefined) {
						this.searchData.filters = {};
					}
					if (event.item.checked) {
						this.searchData.filters[event.item.facetName] = event.item.value;
					} else {
						delete this.searchData.filters[event.item.facetName];
					}
					await this.DoSearch();
					break;
				}
				case eParticaAction.DO_SEARCH: {
					this.searchData.filters = undefined;
					this.searchData.query = event.item as string;
					await this.DoSearch();
					break;
				}
				case eParticaAction.CHANGE_SEARCH_RETURN_COUNT: {
					this.searchData.top = event.item as number;
					await this.DoSearch();
					break;
				}
				case eParticaAction.ARTICLE_SELECT: {
					this.$emit("partica-event", event);
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (e) {
			this.ShowErrorDialog(e, `Unable to process event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.articleSearchService = this.particaServices.getArticleSearchService();
			if (this.searchData !== undefined) {
				if (this.orderby !== undefined) {
					this.searchData.orderby = [this.orderby];
				}
				if (this.articleType !== undefined && this.searchData.filters !== undefined) {
					// tslint:disable-next-line
					this.searchData.filters["article_type"] = this.articleType;
				} else {
					if (this.articleType !== undefined && this.facets !== undefined) {
						ArrayUtils.remove(this.facets, "article_type");
					}
				}
				if (this.facets !== undefined) {
					this.searchData.facets = this.facets;
				}
			}
			await this.DoSearch();
		} catch (e) {
			this.ShowErrorDialog(e, `Error initializing component.`);
		} finally {
			this.LoadingEnd();
		}

	}

	private async DoSearch() {
		if (this.publicationId !== undefined) {
			this.searchData = await this.articleSearchService.SearchPublicationArticles(this.publicationId, this.searchData);
		} else if (this.accountId !== undefined) {
			this.searchData = await this.articleSearchService.SearchAccountArticles(this.accountId, this.searchData);
		} else {
			this.searchData = await this.articleSearchService.SearchGlobal(this.searchData);
		}
	}
}
